var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_3178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00250244V16.0025H24V-0.00250244H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 9.49998L13.155 9.07248L13.5 10.175L12.5625 9.49998ZM10.5 10.175L10.8675 9.04998L11.46 9.47748L10.5 10.175ZM10.725 7.24998L10.5 7.99998L9.54 7.24998H10.725ZM13.5 7.99998L13.275 7.24998H14.46L13.5 7.99998ZM12.3675 6.64248H11.6175L12 5.48748L12.3675 6.64248ZM11.0625 8.40498L11.415 7.24998H12.5775L12.9375 8.35248L12 9.06498L11.0625 8.40498ZM16.5 6.61998H13.065L12 3.34998L10.935 6.61998H7.5L10.2825 8.63748L9.2175 11.9075L12 9.88248L14.7825 11.9075L13.7175 8.63748L16.5 6.61998Z",
    fill: "#006233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_3178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/Morocco.5df357a4a795bac328e13c707a3b0e08.svg";
export { ForwardRef as ReactComponent };